
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 12.7 11.321","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.3 0a.297.297 0 0 0-.19.064l-6 4.4c-.15.11-.18.31-.071.46.11.15.31.18.46.071l5.8-4.3 5.8 4.3c.059.043.13.064.19.064.1 0 .2-.047.27-.14a.326.326 0 0 0-.071-.46l-6-4.4a.338.338 0 0 0-.19-.064zm4.6 5.1c-.18 0-.33.15-.33.33v5.3h-2.6v-2.9c0-.91-.74-1.7-1.6-1.7-.91 0-1.7.74-1.7 1.7v2.9h-2.6v-5.3c0-.18-.15-.33-.33-.33s-.33.15-.33.33v5.6c0 .18.15.33.33.33h3.3a.328.328 0 0 0 .331-.326v-3.2c0-.55.44-.99.99-.99s.99.44.99.99v3.2a.33.33 0 0 0 .331.325h3.3c.18 0 .33-.15.33-.33v-5.6c0-.18-.15-.33-.33-.33z","fill":"#191919"}})])
      }
    
      }
    